import React from 'react';

import ListItem from './ListItem';

const List = ({ payments, handleDeleteCard, setDefaultPayment }) => {
  return (
    (payments && payments.length && (
      <ul className="address-list payment-list">
        {payments.map(payment => (
          <ListItem
            key={payment.uid}
            payment={payment}
            setDefaultPayment={setDefaultPayment}
            handleDeleteCard={handleDeleteCard}
          />
        ))}
      </ul>
    )) || <noscript />
  );
};

export default List;
